// extracted by mini-css-extract-plugin
export default {"badEntry":"loginForm_badEntry__R0ZYH","microsoftLoginButton":"loginForm_microsoftLoginButton__MZnoy"};